import { useQuery } from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { FISCAL_YEAR_API } from "./apiRoutes";

const fetchFiscalYearDetails = async (communityId: string | number, fiscalYear: string | number) => {
  const res = await axiosAuth.get(`${FISCAL_YEAR_API(communityId)}/${fiscalYear}`);
  return res.data;
};

const useGetFiscalYearDetails = ({communityId, fiscalYear}: {communityId?: string | number, fiscalYear?: string | number}) =>
  useQuery({
    queryKey: ["fiscal-year-dtl", communityId, fiscalYear],
    queryFn: () => fetchFiscalYearDetails(communityId!, fiscalYear!),
    select: (data: any) => data.data,
    enabled: !!communityId && !!fiscalYear,
  });

export default useGetFiscalYearDetails;